import React from 'react';
import {useSelector} from "react-redux";
import {Checkbox, TableCell, TableHead, TableRow, TableSortLabel} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MenuItem from "@material-ui/core/MenuItem";
import ListHoc from "../../../../../HocHelpers/ListHoc";
import {multiLanguageValue} from "../../../../JsonScreen/Utils/lib";

const TableHeaderList = (props) => {
    const {selectable, columns, sortable, pivotColumns = [], layoutType} = props;
    const currentColumns = pivotColumns.length > 0 ? pivotColumns : columns;
    return (
        <TableHead>
            <TableRow style={{height: 27}}>
                {selectable && <CellCheckbox/>}
                <HeaderCells
                    currentColumns={currentColumns}
                    layoutType={layoutType}
                    sortable={sortable}
                />
            </TableRow>
        </TableHead>
    )
}

const CellCheckbox = () => {
    return (
        <TableCell padding={"checkbox"}
                   style={{
                       whiteSpace: 'nowrap',
                       overflow: 'hidden',
                       padding: '0px',
                       position: 'sticky',
                       background: '#fff',
                       zIndex: 99,
                       width: 54,
                       top: 0
                   }}
        >
            <Checkbox
                disabled
                style={{padding: 0}}
                color={"primary"}
            />

            <IconButton
                style={{padding: '3px'}}
                aria-haspopup="true"
                disabled
            >
                <ArrowDropDownIcon/>
            </IconButton>
            <Menu
                open={false}
                id="long-menu"
            >
                <MenuItem style={{padding: '3px 5px', fontSize: '1rem'}}>
                    None
                </MenuItem>
            </Menu>
        </TableCell>
    )
};
const HeaderCells = ({currentColumns = [], layoutType, sortable}) => {
    const {userLanguage} = useSelector(state => state.app);
    return(
        currentColumns.map((headCell, index) => {
            const {hidden, type, label, name, width} = headCell;
            const multiLanguageLabel = multiLanguageValue(label, userLanguage)
            return (
                !hidden && (
                    <TableCell
                        key={index}
                        style={{
                            textAlign: type === 'number' || type === 'integer' ? 'right' : 'left',
                            whiteSpace: 'nowrap',
                            position: 'sticky',
                            background: '#fff',
                            top: 0,
                            zIndex: 99,
                            fontWeight: 600,
                            color: '#696C6E',
                            overflow: 'hidden',
                            padding: '4px 16px',
                            width: layoutType === 'fixed' ? width || 'auto' : 'auto',
                        }}
                    >
                        {sortable ? (
                            <TableSortLabel direction={'asc'}>
                                {!multiLanguageLabel ? name : multiLanguageLabel}
                            </TableSortLabel>
                        ) : (
                            !multiLanguageLabel ? name : multiLanguageLabel
                        )}
                    </TableCell>
                )
            )
        })
    )
}

export default ListHoc(TableHeaderList);